import { isEmpty } from "lodash";
import { SMART_KID_OPTION_VALUES } from "@ipru-common/constants/InputValues";
import QuoteFormStore from "@ipru-common/store/QuoteFormStore";
import { getCurrentProductFromMeta } from "../CommonFunctions";
import { PRODUCT_KEYS } from "@ipru-common/constants/products";

export const calculateMinPerformanceValue = (selectedFund) => {
  const perf1Year = parseFloat(selectedFund?.Perf1Year);
  const perf3Year = parseFloat(selectedFund?.Perf3Year);
  const perf5Year = parseFloat(selectedFund?.Perf5Year);

  const validValues = [perf1Year, perf3Year, perf5Year].filter((value) => !isNaN(value) && value >= 8);

  if (isEmpty(validValues)) {
    return { selectedValue: 0, minValue: 0 };
  }

  const minValue = Math.min(...validValues);

  const minOptionId =
    minValue === perf1Year
      ? SMART_KID_OPTION_VALUES.RETURN_YEARS.ONE_YEAR
      : minValue === perf3Year
        ? SMART_KID_OPTION_VALUES.RETURN_YEARS.THREE_YEARS
        : SMART_KID_OPTION_VALUES.RETURN_YEARS.FIVE_YEARS;

  let selectedValue = minOptionId;

  return { selectedValue, minValue };
};

export const getDefaultPerformanceValue = (selectedFund) => {
  let selectedValue;
  let minValue;
 if (!isNaN(parseFloat(selectedFund?.Perf3Year))) {
    selectedValue = SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.THREE_YEARS;
    minValue= parseFloat(selectedFund?.Perf3Year);
  }
  else if (!isNaN(parseFloat(selectedFund?.Perf10Year))) {
    selectedValue = SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.TEN_YEARS;
    minValue= parseFloat(selectedFund?.Perf10Year);
  }
  else if (!isNaN(parseFloat(selectedFund?.Perf5Year))){
    selectedValue = SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.FIVE_YEARS;
    minValue= parseFloat(selectedFund?.Perf5Year);
  }
  else{
    selectedValue = SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.RSI;
    minValue= parseFloat(selectedFund?.PerfInception);
  }
  return { selectedValue, minValue };
};
export const getDefermentPeriod = () => {
  const QuoteFormValues = QuoteFormStore.getQuoteFormData();
  return QuoteFormValues?.incomeStartsFrom - QuoteFormValues?.ppt - 1 > 0
    ? QuoteFormValues?.incomeStartsFrom - QuoteFormValues?.ppt - 1
    : 0;
};

export function updateRidersRequestBody(obj, namedObj) {
  if (getCurrentProductFromMeta() === PRODUCT_KEYS.GIFTPRO && obj?.ProductDetails?.Product?.RiderDetails?.Rider) {
    obj.ProductDetails.Product.RiderDetails?.Rider.forEach((rider) => {
      if (namedObj[rider.Name]) {
        rider.Name = namedObj[rider.Name];
      }
    });
  }
  return obj;
}

export function updateRidersName(riders, namedObj, fieldName) {
  if (getCurrentProductFromMeta() === PRODUCT_KEYS.GIFTPRO && riders) {
    riders.forEach((rider) => {
      if (namedObj[rider[fieldName]]) {
        rider[fieldName] = namedObj[rider[fieldName]];
      }
    });
  }
  return riders;
}
